export default "__VITE_ASSET__K296LX78__"